import script from "./toast-alert.vue?vue&type=script&setup=true&lang=js"
export * from "./toast-alert.vue?vue&type=script&setup=true&lang=js"

import "./toast-alert.vue?vue&type=style&index=0&id=9cbb0eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cbb0eba"]])

export default __exports__